import { createTheme } from '@mui/material/styles';

export default createTheme({
  palette: {
    primary: {
      main: '#E65C1C', // Vertilocity orange
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#333333', // Dark gray for text
    },
    background: {
      default: '#FFFFFF',
    },
  },
  typography: {
    h4: {
      fontWeight: 600,
      color: '#333333',
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
    },
  },
}); 